export default __webpack_public_path__ + "static/media/veqtor_linea-tiempo.10918104.svg";